import api from '@edu-fe/api'

export default {
  name: 'getRead',
  get: (from) => api.create('/daily/subscribe', {
    method: 'POST',
    data: {
      from
    },
    formData: true
  }),
  getState: api.create(`/daily/is/subscribe`)
}
